document.addEventListener('DOMContentLoaded', function() {
  function applyFormStyles() {
    var embed = document.querySelector('shopify-forms-embed');
    if (!embed || !embed.shadowRoot) return false;

    var shadow = embed.shadowRoot;
    var input = shadow.querySelector('#first_name');
    if (!input) return false;

    // --- INJECT CSS VÀO ĐÚNG VỊ TRÍ TRONG SHADOW DOM ---
    var existingStyle = shadow.querySelector('#elemital-form-style');
    if (!existingStyle) {
      var style = document.createElement('style');
      style.id = 'elemital-form-style';
      style.textContent = `
        /* Reset font toàn bộ form */
        * {
          font-family: 'SVN-Gilroy Regular', sans-serif !important;
        }

        /* Labels */
        ._formInputFieldLabel_1mxsl_38,
        ._label_12thd_10,
        ._checkboxLegend_1hja3_20 {
          font-size: 1.4rem !important;
          color: #333333 !important;
        }

        /* Đưa label lên trên input (bỏ floating label) */
        ._formFieldContainer_1mxsl_5 {
          display: flex !important;
          flex-direction: column-reverse !important;
          gap: 0.6rem !important;
        }

        ._formInputFieldLabel_1mxsl_38 {
          position: static !important;
          transform: none !important;
          top: auto !important;
          left: auto !important;
          pointer-events: none !important;
        }

        /* Tăng font checkbox "Yes, I would like..." */
        ._checkboxField_1hja3_3 span._textBody_2aowh_10,
        label._checkboxField_1hja3_3 ._textBody_2aowh_10 {
          font-size: 1.6rem !important;
          line-height: 1.5 !important;
        }

        /* Tăng chiều cao ô "How can we help you" */
        ._textArea_17mgw_1 {
          min-height: 16rem !important;
        }

        /* Padding giữa các field */
        ._formFieldContainer_1mxsl_5,
        ._selectContainer_12thd_6,
        ._checkboxFieldSet_1hja3_3 {
          margin-bottom: 1.6rem !important;
        }

        /* Input fields */
        ._formInputField_nag3b_7,
        ._textArea_17mgw_1,
        ._selectToggle_12thd_25 {
          font-size: 1.5rem !important;
          color: #333333 !important;
        }

        /* Dropdown options */
        ._selectOptionList_12thd_62,
        ._selectOption_12thd_62,
        [class*="_selectOption"] {
          font-size: 1.5rem !important;
          color: #333333 !important;
        }

        /* Checkbox to hơn */
        ._checkboxInput_1hja3_38 {
          accent-color: #31482C !important;
          width: 1.6rem !important;
          height: 1.6rem !important;
          min-width: 1.6rem !important;
          min-height: 1.6rem !important;
        }

        /* Submit button — vừa text, căn giữa */
        ._formSubmitButton_cit2d_96 {
          font-family: 'SVN-Gilroy Regular', sans-serif !important;
          font-size: 1.6rem !important;
          background-color: #D9E5B3 !important;
          color: #31482C !important;
          border: 1px solid #D9E5B3 !important;
          border-radius: 0.6rem !important;
          width: fit-content !important;
          min-width: 18rem !important;
          padding: 1.4rem 4rem !important;
          display: flex !important;
          align-self: center !important;
          margin: 0 auto !important;
        }

        ._formSubmitButton_cit2d_96:hover {
          background-color: #31482C !important;
          color: #ffffff !important;
          border-color: #31482C !important;
        }

        /* Ẩn disclaimer */
        ._formDisclaimer_cit2d_38 {
          display: none !important;
        }

        /* Form căn trái */
        ._formHeader_cit2d_24 {
          display: none !important;
        }

        /* Căn giữa form + giới hạn width */
        ._inline_1q1d2_47,
        ._formContainer_1q1d2_30,
        #form-container-ref {
          max-width: 72rem !important;
          width: 100% !important;
          margin: 0 auto !important;
        }

        ._gridItemContent_1q1d2_257 {
          padding: 2rem 0 4rem 0 !important;
        }

        ._container_3eyaa_70 {
          justify-content: center !important;
        }

        /* Đảm bảo form là flex column để align-self của button hoạt động */
        ._formFieldset_cit2d_82 {
          display: flex !important;
          flex-direction: column !important;
        }

        /* 2 cột First name / Last name */
        .elemital-name-row {
          display: flex !important;
          flex-direction: row !important;
          gap: 1.6rem !important;
          width: 100% !important;
        }

        .elemital-name-row > ._formFieldContainer_1mxsl_5 {
          flex: 1 1 0% !important;
          width: auto !important;
          min-width: 0 !important;
        }
      `;
      /* Insert vào đúng container, không phải firstChild của shadowRoot */
      var appRoot = shadow.querySelector('#app-embed');
      if (appRoot) {
        appRoot.insertBefore(style, appRoot.firstChild);
      } else {
        shadow.appendChild(style);
      }
    }

    // --- ẨN "No, thanks" ---
    shadow.querySelectorAll('label').forEach(function(label) {
      if (label.textContent.trim() === 'No, thanks') {
        label.style.display = 'none';
      }
    });

    // --- 2 CỘT FIRST + LAST NAME ---
    if (!shadow.querySelector('.elemital-name-row')) {
      var firstNameInput = shadow.querySelector('#first_name');
      var lastNameInput = shadow.querySelector('#last_name');
      var firstNameContainer = firstNameInput ? firstNameInput.parentElement : null;
      var lastNameContainer = lastNameInput ? lastNameInput.parentElement : null;
      var parent = firstNameContainer ? firstNameContainer.parentElement : null;

      if (firstNameContainer && lastNameContainer && parent &&
          firstNameContainer !== lastNameContainer &&
          firstNameContainer.parentElement === lastNameContainer.parentElement) {
        var row = document.createElement('div');
        row.className = 'elemital-name-row';
        parent.insertBefore(row, firstNameContainer);
        row.appendChild(firstNameContainer);
        row.appendChild(lastNameContainer);
      }
    }

    return true;
  }

  // MutationObserver đợi form load
  var observer = new MutationObserver(function(mutations, obs) {
    var embed = document.querySelector('shopify-forms-embed');
    if (embed && embed.shadowRoot && embed.shadowRoot.querySelector('#first_name')) {
      applyFormStyles();
      obs.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Fallback
  setTimeout(applyFormStyles, 1500);
  setTimeout(applyFormStyles, 3000);
});